/*
 * @Author: pengzhihui
 * @Description:
 * @Date: 2020-05-08 10:48:10
 * @LastEditTime: 2021-04-08 20:36:02
 */
export default function request<T>({ url = '', withCredentials = true }): Promise<T> {
    return new Promise((resolve, reject) => {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', url);
        (xhr as any).responseType = 'JSON';
        xhr.withCredentials = withCredentials;
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                let res = JSON.parse(xhr.response);
                if (res.result !== 1) {
                    reject(res);
                } else {
                    resolve(res);
                }
            }
        };
        xhr.onerror = (err) => {
            reject(err);
        };
        xhr.send();
    });
}
